import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import {environment} from '@environments/environment';
import {Rive} from '@rive-app/canvas';

const RIVE_CONFIG = {
  ekstraklasa: {src: '/assets/rive/esa_tv_loader.riv', artboard: 'ESATV_Loader'},
  lff: {src: '/assets/rive/futbolas.riv', artboard: 'lt-loader'},
};

@Component({
  selector: 'app-rive-loader',
  templateUrl: './rive-loader.component.html',
  styleUrls: ['./rive-loader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RiveLoaderComponent implements OnInit, OnDestroy {
  @ViewChild('riveCanvas', {static: true}) canvasRef!: ElementRef<HTMLCanvasElement>;

  client = environment.name;

  riveInstance?: Rive;

  ngOnInit() {
    try {
      const canvas = this.canvasRef.nativeElement;

      this.riveInstance = new Rive({
        ...RIVE_CONFIG[this.client as keyof typeof RIVE_CONFIG],
        canvas,
        autoplay: true,
        onLoad: () => {
          this.riveInstance?.resizeDrawingSurfaceToCanvas();
        },
      });
    } catch (error) {
      console.error('Rive initialization error:', error);
    }
  }

  ngOnDestroy(): void {
    this.riveInstance?.cleanup();
  }
}
